module.exports = __webpack_public_path__ + "img/img38.868f1aaa.svg";